import { useIncomingMessageSound } from '@app/pages/Leads/model';
import { SoundToggleButton } from '@app/pages/Leads/ui/components/SoundToggleButton';

import type { FC } from 'react';

import './LeadCardPageHeader.scss';

export const LeadCardPageHeader: FC = () => {
  const { incomingMessageSoundToggleHandler, isIncomingMessageSoundEnabled } =
    useIncomingMessageSound();

  return (
    <div className="LeadCardPageHeader">
      <div className="LeadCardPageHeader__actions">
        <SoundToggleButton
          className="LeadCardPageHeader__sound-toggle"
          isSoundEnabled={isIncomingMessageSoundEnabled}
          onToggleSound={incomingMessageSoundToggleHandler}
        />
      </div>
    </div>
  );
};
